<template>
  <div class="container">
    <Header class="header" data-title="이벤트" :type="'share'" :shareParam="shareParam"></Header>
    <!-- content(s) -->
    <div id="content">
      <div class="eventView img" v-html="eventInfo"></div>

      <section v-if="spEbDbInputYn === 'Y'">
        <div class="wrapper">
          <div class="container event_box">
            <!-- content(s) -->
            <div id="content">
              <section class="hr">
                <div class="formArea">
                  <span v-if="dbInputPrdList.length > 1" class="label">
                    상품
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <select class="ipt" v-if="dbInputPrdList.length > 1" title="상품선택" v-model="productCode">
                    <option value="">상품을 선택하세요</option>
                    <option v-for="(value, key) in dbInputPrdList" :key="key" :value="value.prodCode">{{ value.prodName }}</option>
                  </select>

                  <span class="label">
                    이름
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <input type="text" id="ipt4" class="ipt" title="이름 입력" value="" v-model="userName" />

                  <span class="label">
                    휴대폰번호
                    <span class="required"><span class="blind">필수</span></span>
                  </span>
                  <input
                    type="tel"
                    id="phone_2"
                    class="ipt"
                    title="휴대폰 번호 입력"
                    placeholder="' - ' 없이 입력해주세요."
                    value=""
                    v-model="cellNum"
                    v-onlyNum
                  />

                  <!-- 약관 (s) -->
                  <div class="termsWrap">
                    <div class="inner">
                      <ul class="iptGroup">
                        <li>
                          <div class="block">
                            <input type="checkbox" class="ipt" name="terms1" id="terms1_3" v-model="terms" />
                            <label for="terms1_3">
                              <span>[필수]</span>
                              개인정보수집 및 이용약관 동의
                            </label>
                            <button type="button" class="links arrow" @click="popupOpen"><span class="blind">상세약관 전체보기</span></button>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <!-- 약관 (e) -->
                </div>

                <div class="btnArea">
                  <button type="button" class="btn_p" @click="requestConsult" :disabled="regButtonShow">{{ spEbDbInputBtnNm }}</button>
                </div>
              </section>
              <div class="img event_dbimg">
                <img class="dbimg01" src="https://www.welrix.com/img_1/welmall_comm_img/1659919590764_event_end_01.jpg" style="display: none" />
                <img class="dbimg02" src="https://www.welrix.com/img_1/welmall_comm_img/1659919601908_event_end_02.jpg" style="display: none" />
                <img class="dbimg03" src="https://www.welrix.com/img_1/welmall_comm_img/1659919611808_event_end_03.jpg" style="display: none" />
                <img class="dbimg04" src="https://www.welrix.com/img_1/welmall_comm_img/1659919622414_event_end_04.jpg" style="display: none" />
                <img class="dbimg05" src="https://www.welrix.com/img_1/welmall_comm_img/1659919632510_event_end_05.jpg" style="display: none" />
                <img class="dbimg06" src="https://www.welrix.com/img_1/welmall_comm_img/1659919642466_event_end_06.jpg" style="display: none" />
              </div>
              <MessagePop v-if="messagePopFlag" @close="msgClose">
                <p v-html="msg"></p>
              </MessagePop>
              <CallServiceTermPop v-if="CallServiceTermPopFlag" @close="msgClose" @agree="agree"></CallServiceTermPop>
            </div>
            <!-- content(e) -->
          </div>
        </div>
      </section>
      <section class="hr" v-for="(value, key) in prdList" :key="key">
        <div class="titArea">
          <p class="titH4" v-text="value.productGroupName"></p>
        </div>

        <ul class="prdList bbNone">
          <li v-for="(product, productIndex) in value.products" :key="productIndex">
            <div class="block">
              <div class="prdItem full">
                <div class="imgArea">
                  <div class="badgeArea">
                    <span class="badge" v-for="(topTags, topTagsIndex) in product.tagInfos.topTags" :key="topTagsIndex">
                      <img :src="topTags.imgPath" />
                    </span>
                  </div>
                  <a class="img imgCover" @click="goProductDetail(product.productIndex, product.discntFlag)">
                    <img :src="product.thumbnail" :alt="product.displayName" />
                  </a>
                </div>
                <div class="infoArea">
                  <a class="tit row2" @click="goProductDetail(product.productIndex, product.discntFlag)">
                    <span v-text="product.productName"></span>
                  </a>
                  <div class="txtItem">
                    <span v-text="product.model"></span>
                  </div>
                  <div class="hashtag">
                    <span
                      v-for="(bottomTags, bottomTagsIndex) in product.tagInfos.bottomTags"
                      :key="bottomTagsIndex"
                      v-text="bottomTags.tagName"
                    ></span>
                  </div>
                  <div class="price" v-if="product.isOnepay == 'N'">
                    <span class="money del">
                      월
                      <span v-text="getConvertPrice(product.rentalAmount)"></span>
                      원
                    </span>
                    <br />
                    <span class="money pointC1">
                      월
                      <em v-text="getConvertPrice(product.cardDCrentalAmount)"></em>
                      원
                      <i>/제휴카드가</i>
                    </span>
                  </div>

                  <div class="price" v-if="product.isOnepay == 'Y'">
                    <span class="money del"></span>
                    <br />
                    <span class="money pointC1">
                      구매가
                      <em v-text="getConvertPrice(product.saleAmount)"></em>
                      원
                      <i></i>
                    </span>
                  </div>

                  <ul class="utilBtn">
                    <li>
                      <a :class="{ icoBtn: true, zzim: true, on: value.wishItem }" @click="updateWishList(product)">
                        <span>
                          찜 (
                          <i v-text="getConvertPrice(product.wishCount)"></i>
                          )
                        </span>
                      </a>
                      <!-- 클래스 on -->
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </section>

      <section class="full mt0">
        <div class="btnArea">
          <button type="button" class="btn_s" @click="goEventList">목록</button>
        </div>
      </section>
      <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop">
        <p v-html="msg"></p>
      </ConfirmPop>

      <UpdateWishList ref="wish" @updateWishCount="updateWishCount"></UpdateWishList>
    </div>
    <!-- content(e) -->
    <QuickMenu></QuickMenu>
  </div>
  <!-- container(e) -->
</template>
<script>
import * as customjs from '@/../static/js/m.front.js';
import QuickMenu from '@/views/app/comm/QuickMenu';
import ApiService from '@/common/api.service';
import { convertPrice } from '@/common/common.filter';
import UpdateWishList from '@/components/comm/UpdateWishList';
import JwtService from '@/common/jwt.service';
import ConfirmPop from '@/components/popup/ConfirmPop';
import { INPUT_INFO_CHECK, TERM_AGREE_CHECK, PDP_RESERVATION_ADVICE } from '@/store/message.type.js';
import { isEmpty } from '@/common/common.function';
import CallServiceTermPop from '@/views/app/comm/CallServiceTermPop';
import MessagePop from '@/components/popup/MessagePop';

export default {
  name: 'eventDetail',
  data() {
    return {
      eventInfo: null,
      prdList: [],
      dbInputPrdList: [],
      spEbDbInputYn: '',
      spEbDbInputBtnNm: '',
      idx: this.$route.params.idx,
      shareParam: {
        img: '',
        title: '',
        index: this.$route.params.idx,
      },

      confirmPop: false,
      cellNum: null,
      userName: null,
      terms: null,
      CallServiceTermPopFlag: null,
      orderType: null,
      productCode: '',
      internalProdCode: null,

      messagePopFlag: null,
      msg: null,
      marParam: '', //마케팅정보
      regButtonShow: true,
    };
  },
  components: {
    QuickMenu,
    UpdateWishList,
    ConfirmPop,
    MessagePop,
    CallServiceTermPop,
  },
  mounted() {
    this.JWTsetMarParam(); // JWT set Marparam (echo_key, g_code)

    ApiService.service('GET', '/board/event/' + this.idx)
      .then(({ data }) => {
        console.log(data);
        this.eventInfo = data.result.spEbContent;
        this.shareParam.img = data.result.spEbThumnail;
        this.shareParam.title = data.result.spEbTitle;
        this.spEbDbInputYn = data.result.spEbDbInputYn;
        this.spEbDbInputBtnNm = data.result.spEbDbInputBtnNm ? data.result.spEbDbInputBtnNm : '신청하기';

        if (data.result.productsInfo) {
          this.prdList = data.result.productsInfo;
        }

        if (data.result.dbInputproductsInfo) {
          this.dbInputPrdList = data.result.dbInputproductsInfo;

          if (this.dbInputPrdList.length === 1) {
            this.productCode = this.dbInputPrdList[0].prodCode;
          }
        }
      })
      .catch(({ response }) => {
        console.log('error : ' + response);
      });
    // content 이미지 관련 임시 function
    customjs.setImgSort();
  },
  created() {
    window.add_btn01 = this.add_btn01.bind(this);
    window.add_btn02 = this.add_btn02.bind(this);
    window.shcard_btn01 = this.shcard_btn01.bind(this);
    window.shcard_btn02 = this.shcard_btn02.bind(this);
    window.shcard_btn03 = this.shcard_btn03.bind(this);
    window.shcard_btn04 = this.shcard_btn04.bind(this);
    window.welbank_btn01 = this.welbank_btn01.bind(this);
    window.loca_btn01 = this.loca_btn01.bind(this);
    window.woori_card_btn01 = this.loca_btn01.bind(this);
  },
  watch: {
    userName() {
      this.checkInput();
    },
    cellNum() {
      this.checkInput();
    },
    terms() {
      this.checkInput();
    },
  },
  methods: {
    requestConsult() {
      this.passValidate = true;
      if (!this.terms) {
        this.msg = TERM_AGREE_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.cellNum == null || this.cellNum == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.userName == null || this.userName == '') {
        this.msg = INPUT_INFO_CHECK;
        this.messagePopFlag = true;
        this.passValidate = false;
      }

      if (this.passValidate) {
        let product = this.dbInputPrdList.find((row) => {
          if (row.prodCode === this.productCode) return true;
        });
        if (product.saleDivCd === 'RTSL0003') {
          this.orderType = 'RORT00SE';
        } else {
          this.orderType = 'RORT00GE';
        }
        let param = new Object();
        let request = new Object();

        if(JwtService.getMarParam() && JwtService.getMarParam != null){
          request.marParam = JwtService.getMarParam();
        }
        request.cellNum = this.cellNum;
        request.internalProdCode = this.productCode;
        request.orderName = this.userName;
        request.saleType = this.orderType;
        request.userId = this.userId;
        request.sellerEmp = 'WM_APP';

        param.request = request;
        param.serviceType = 'app';

        console.log(param);

        ApiService.service('POST', '/order/regist/simple', param)
          .then(({ data }) => {
            console.log('data:::::', data);
            if (data.isSucceed) {
              this.msg = PDP_RESERVATION_ADVICE;
              this.messagePopFlag = true;
              const params = {
                af_content_id: this.productCode,
              };

              window.appsFlyer('af_complete_reservation', params);

              //this.$router.go(-1);
            } else {
              this.passValidate = false;
              //this.msg = SERVICE_COMM_ERROR;
              this.msg = '단종된 상품입니다.';
              this.messagePopFlag = true;
            }
          })
          .catch(({ response }) => {
            console.log('error : ' + response);
          });
      }
    },
    goEventList() {
      this.$router.push('/submain/event');
    },
    JWTsetMarParam() {
      // getMarparam에 값이 없을 경우 JWT토큰에 값 세팅
      console.log('jwt => ' + JwtService.getMarParam());

      if (JwtService.getParamTime() != null && JwtService.getParamTime != null) {
        let now = new Date();
        let diffTime = now - diffTime;
        //40분 이상 된 G코드, 에코키 삭제
        if (diffTime / (1000 * 60) > 40) {
          JwtService.destroyMarParam();
        }
      }
      var param = location.search.substr(location.search.indexOf('?') + 1);
      param = param.split('&');
      var temp = '';
      for (var i = 0; i < param.length; i++) {
        temp = param[i].split('=');
        if (temp[0] == 'g') {
          this.gCode = temp[1];
        }
        if (temp[0] == 'echo_key') {
          this.echoKey = temp[1];
        }
        if (!(this.echoKey == undefined && this.gCode == undefined)) {
          var marParam = this.echoKey + '/' + this.gCode;
          JwtService.setMarParam(marParam);
          this.marParam = JwtService.getMarParam();
        }
      }

      // if (!JwtService.getMarParam() || JwtService.getMarParam == null) {
      //   var param = location.search.substr(location.search.indexOf('?') + 1);
      //   param = param.split('&');
      //   var temp = '';
      //   for (var i = 0; i < param.length; i++) {
      //     temp = param[i].split('=');
      //     if (temp[0] == 'g') {
      //       this.gCode = temp[1];
      //     }
      //     if (temp[0] == 'echo_key') {
      //       this.echoKey = temp[1];
      //     }
      //     if (!(this.echoKey == undefined && this.gCode == undefined)) {
      //       var marParam = this.echoKey + '/' + this.gCode;
      //       JwtService.setMarParam(marParam);
      //       this.marParam = JwtService.getMarParam();
      //     }
      //   }
      // }
    },
    goProductDetail(productCode, discntFlag) {
      if (productCode != '0' && discntFlag != 'Y') {
        this.$router.push({
          name: 'productDetail',
          params: { idx: productCode },
        });
      }
    },
    getConvertPrice(value) {
      return convertPrice(value);
    },
    updateWishList(product) {
      this.$refs.wish.updateWishList(product);
    },
    updateWishCount(product, flag, count) {
      product.wishItem = flag;
      product.wishCount += count;
    },
    /*회원가입 쿠폰팩 이벤트 sp_eb_idx = 96*/
    add_btn01() {
      if (JwtService.getToken()) {
        this.$router.push('/benefits/coupon');
      } else {
        this.$router.push({ name: 'login', params: { redirect: 'benefitsCoupon' } });
      }
    },
    /*앱 리뷰작성 이벤트 sp_eb_idx = 99*/
    add_btn02() {
      if (JwtService.getToken()) {
        this.$router.push('/reviewEvent');
      } else {
        this.confirmPop = true;
        this.msg = '로그인이 필요한 페이지 입니다.';
      }
    },
    /*앱 인앱 이벤트 sp_eb_idx = 100*/
    add_btn03() {
      window.appsFlyer('af_event_freetrial', null);
    },
    /*confirmPop 닫을때*/
    close() {
      this.confirmPop = false;
    },
    /*confirmPop 취소선택*/
    cancel() {
      this.confirmPop = false;
    },
    /*confirmPop 확인선택*/
    confirm() {
      this.$router.push({ name: 'login', params: { redirect: 'reviewEvent' } });
    },
    /*앱 인앱 이벤트 sp_eb_idx = 106*/
    shcard_btn01() {
      window.location.href = 'https://www.shinhancard.com/pconts/html/card/apply/credit/1192802_2207.html?EntryLoc2=2969&empSeq=523&btnApp=dp13';
    },
    shcard_btn02() {
      window.location.href = 'https://www.shinhancard.com/pconts/html/card/apply/credit/1187937_2207.html?EntryLoc2=2774&empSeq=961&btnApp=DP013';
    },
    shcard_btn03() {
      window.location.href =
        'https://www.shinhancard.com/evt/MOBEVENTN/MOBEVT024R10.shc?rvN=2023011827HMPG&rtrn_url=https://m.welrix.com/event/detail/131';
    },
    shcard_btn04() {
      window.location.href =
        'https://www.shinhancard.com/evt/MOBEVENTN/MOBEVT024R10.shc?rvN=2022121926HMPG&rtrn_url=https://m.welrix.com/event/detail/131';
    },
    /* 앱 인앱 이벤트 20210820 이동황 대리 요청 */
    welbank_btn01() {
      window.location.href = 'https://m.welcomebank.co.kr/ib20/mnu/MWBCCTTOP060?afficoCd=WLX2108';
    },
    loca_btn01() {
      window.location.href = 'https://m.lottecard.co.kr/spa/card/booth?bId=76594&vtCdKndC=P13998-A13998';
    },
    woori_card_btn01() {
      window.location.href = `https://m.wooricard.com/dcmw/yh1/crd/crd01/M1CRD101S02.do?cdPrdCd=102314&canvasser=88930035`;
    },
    daekyo_btn01() {
      window.location.href = `https://forms.gle/mDVCDcD6gavecS9XA`;
    },
    msgClose() {
      this.messagePopFlag = false;
      this.CallServiceTermPopFlag = false;
      if (this.passValidate) {
        this.$router.go(-1);
      }
    },
    agree() {
      this.terms = true;
      this.CallServiceTermPopFlag = false;
    },
    popupOpen() {
      this.CallServiceTermPopFlag = true;
    },
    checkInput() {
      if (!isEmpty(this.userName) && !isEmpty(this.cellNum) && this.terms === true) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
};
</script>
